import * as React from "react";
import {useTranslation} from "react-i18next";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";
import window, {IAmazonError} from "../../../lib/WindowExtended";
import {useEffect} from "react";
import {amazonPayWalletReadableContainerId, widgetOptions} from "../../../lib/payments/AmazonPayLibrary";

interface ISummaryPaymentOptionProps {
  goToPaymentView: () => void;
  onError: (error: IAmazonError) => void;
}

const SummaryShippingOption: React.FC<ISummaryPaymentOptionProps> = (props) => {
  const {checkout} = useCheckoutContext();
  const {t} = useTranslation("checkout");
  const {goToPaymentView} = props;

  useEffect(() => {
    if (!window.isBillingAgreementPaymentSet || !window.amazon) {
      return;
    }

    new window.OffAmazonPayments.Widgets.Wallet({
      ...widgetOptions,
      amazonOrderReferenceId: window.orderReferenceId,
      onError: props.onError,
      displayMode: "Read",
    })
      .setPresentmentCurrency(window.c_ActiveCurrency)
      .bind(amazonPayWalletReadableContainerId);
  }, []);

  let name = t("Keine gültige Zahlungsart");
  let description = t("Bitte gehen Sie in den Kassenschritt 'Bezahlung'");

  const {paymentInformation} = checkout.cartData;
  if (paymentInformation) {
    name = paymentInformation.paymentName || checkout.paymentId?.toString() || "";
    description = paymentInformation.paymentDescription;
  }

  return (
    <React.Fragment>
      <h2>{t("Zahlungsoptionen")}</h2>
      <span className="Pen" onClick={goToPaymentView}>
        <span className="Svg Svg-Icon-Pen">&#160;</span>
      </span>
      <div className="SimpleRadioList ArrowBorder">
        {window.isBillingAgreementPaymentSet ? (
          <div id={amazonPayWalletReadableContainerId} style={{height: "150px", marginBottom: "1rem"}}>
            {/* Filled by Amazon Pay */}
          </div>
        ) : (
          <div className="SimpleRadioList__SingleLine">
            <p dangerouslySetInnerHTML={{__html: name}} />
            <p dangerouslySetInnerHTML={{__html: description}} />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default SummaryShippingOption;
